(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-localization"] && !Shopify.designMode) return;
  try {
    class MobileCountrySelector extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-mobile-country-button]');
      this.list = this.querySelector('[data-mobile-country-list]');
      this.input = this.querySelector('[data-mobile-country-input]');
      this.form = this.querySelector('form');
      if (!this.button || !this.list || !this.input || !this.form) return;

      this._onButtonClick = (e) => {
        e.preventDefault();
        this.toggle();
      };
      this._onDocumentClick = (e) => {
        if (!this.isOpen()) return;
        if (!this.contains(e.target)) this.close();
      };
      this._onKeyDown = (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
          this.button.focus();
        }
      };
      this._onListClick = (e) => {
        const item = e.target.closest('.mobile-country-selector__item');
        if (item) this._selectItem(item);
      };
      this._onListKeyDown = (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const item = e.target.closest('.mobile-country-selector__item');
        if (!item) return;
        e.preventDefault();
        this._selectItem(item);
      };

      this.button.addEventListener('click', this._onButtonClick);
      this.list.addEventListener('click', this._onListClick);
      this.list.addEventListener('keydown', this._onListKeyDown);
      document.addEventListener('click', this._onDocumentClick);
      document.addEventListener('keydown', this._onKeyDown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onKeyDown);
    }

    _selectItem(item) {
      const code = item.getAttribute('data-country-code');
      if (!code) return;
      if (code === this.input.value) {
        this.close();
        return;
      }
      this.input.value = code;
      this.form.submit();
    }

    isOpen() {
      return this.button.getAttribute('aria-expanded') === 'true';
    }

    open() {
      this.list.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      const current = this.list.querySelector('[aria-current="true"]');
      if (current) current.focus();
    }

    close() {
      this.list.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
    }

    toggle() {
      if (this.isOpen()) this.close();
      else this.open();
    }
  }

  if (!customElements.get('mobile-country-selector')) {
    customElements.define('mobile-country-selector', MobileCountrySelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-compra"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('sticky-compra')) return;

    customElements.define('sticky-compra', class extends HTMLElement {

      connectedCallback() {
        this._ac = new AbortController();
        this._isStuck = false;
        this._hiddenByBottom = false;
        this._invalidCombo = false;
        this._variants = [];
        this._defaultImg = '';
        this._obsIntersect = null;
        this._obsFooter = null;
        this._obsMutation = null;
        this._loadVariants();
        this._setup();
      }

      disconnectedCallback() {
        this._obsIntersect?.disconnect();
        this._obsFooter?.disconnect();
        this._obsMutation?.disconnect();
        this._ac?.abort();
      }

      _loadVariants() {
        const script = this.querySelector('script[type="application/json"]');
        if (!script) return;
        try { this._variants = JSON.parse(script.textContent || '[]'); } catch (e) { this._variants = []; }
        const img = this.querySelector('.sc-thumb-img');
        if (img) this._defaultImg = img.src;
      }

      _findVariant(id) {
        if (!id) return null;
        const s = String(id);
        return this._variants.find((v) => String(v.id) === s) || null;
      }

      _getForm() {
        const section = this.closest('.shopify-section');
        const pid = this.dataset.productId;
        if (!section || !pid) return null;
        return section.querySelector('product-form-component[data-product-id="' + pid + '"]');
      }

      _getIdInput() {
        const form = this._getForm();
        return form ? form.querySelector('input[name="id"]') : null;
      }

      _linkMutationObs() {
        this._obsMutation?.disconnect();
        const input = this._getIdInput();
        if (!input) return;
        this._obsMutation = new MutationObserver(() => {
          const v = this._findVariant(input.value);
          if (v) { this._invalidCombo = false; this._updateBar(v); }
        });
        this._obsMutation.observe(input, { attributes: true, attributeFilter: ['value'] });
      }

      _setup() {
        const _mqDesk = window.matchMedia('(min-width: 750px)');
        if (_mqDesk.matches) return;
        _mqDesk.addEventListener('change', () => {
          if (_mqDesk.matches) {
            this._hide();
            this._obsIntersect?.disconnect();
            this._obsFooter?.disconnect();
            this._obsIntersect = null;
            this._obsFooter = null;
          }
        }, { signal: this._ac.signal });

        const section = this.closest('.shopify-section');
        if (!section) return;
        const buyBlock = section.querySelector('.buy-buttons-block');
        if (!buyBlock) return;
        const footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
        const sig = this._ac.signal;

        this._obsIntersect = new IntersectionObserver((entries) => {
          const e = entries[0];
          if (!e) return;
          const rect = e.target.getBoundingClientRect();
          if (!e.isIntersecting && !this._isStuck) {
            if (rect.bottom < 0 || rect.top < 0) this._show();
          } else if (e.isIntersecting && this._isStuck) {
            this._hiddenByBottom = false;
            this._hide();
          }
        });
        this._obsIntersect.observe(buyBlock);

        if (footer) {
          this._obsFooter = new IntersectionObserver((entries) => {
            const e = entries[0];
            if (!e) return;
            if (e.isIntersecting && this._isStuck) {
              this._hiddenByBottom = true;
              this._hide();
            } else if (!e.isIntersecting && this._hiddenByBottom) {
              const rect = buyBlock.getBoundingClientRect();
              if (rect.bottom < 0 || rect.top < 0) { this._hiddenByBottom = false; this._show(); }
            }
          }, { rootMargin: '200px 0px 0px 0px' });
          this._obsFooter.observe(footer);
        }

        /* (a) Evento principal: shopify:product:select en document con captura */
        document.addEventListener('shopify:product:select', (event) => {
          if (!(event.target instanceof Element)) return;
          if (event.target.closest('.shopify-section') !== section) return;
          if (event.target.closest('product-card')) return;

          const earlyId = event.detail && event.detail.variantId;
          if (earlyId) {
            const v = this._findVariant(earlyId);
            if (v) { this._invalidCombo = false; this._updateBar(v); }
          }

          if (event.promise) {
            event.promise.then((result) => {
              if (result.variant === null) {
                this._invalidCombo = true;
                this._updateBarInvalid(section);
              } else if (result.variant && result.variant.id) {
                const v = this._findVariant(result.variant.id);
                if (v) { this._invalidCombo = false; this._updateBar(v); }
              }
            }).catch(() => {});
          }
        }, { signal: sig, capture: true });

        /* (b) Respaldo 1: change en inputs de variante → leer input[name="id"] tras 150 ms */
        let changeTimer;
        section.addEventListener('change', (event) => {
          if (!(event.target instanceof Element)) return;
          if (!event.target.closest('variant-picker, fieldset')) return;
          clearTimeout(changeTimer);
          changeTimer = setTimeout(() => {
            const input = this._getIdInput();
            if (input && input.value) {
              const v = this._findVariant(input.value);
              if (v) { this._invalidCombo = false; this._updateBar(v); }
            }
          }, 150);
        }, { signal: sig });

        /* (c) Respaldo 2a: MutationObserver sobre input[name="id"] */
        this._linkMutationObs();

        /* (c) Respaldo 2b: popstate para navegación atrás/adelante */
        window.addEventListener('popstate', () => {
          const vid = new URLSearchParams(window.location.search).get('variant');
          if (vid) {
            const v = this._findVariant(vid);
            if (v) { this._invalidCombo = false; this._updateBar(v); }
          }
        }, { signal: sig });

        /* Botón de la barra */
        const btn = this.querySelector('.sc-btn');
        if (btn) btn.addEventListener('click', () => this._handleClick(), { signal: sig });
      }

      _show() {
        this._isStuck = true;
        const bar = this.querySelector('.sc-bar');
        if (bar) bar.setAttribute('data-stuck', 'true');
      }

      _hide() {
        this._isStuck = false;
        const bar = this.querySelector('.sc-bar');
        if (bar) bar.setAttribute('data-stuck', 'false');
      }

      _handleClick() {
        const btn = this.querySelector('.sc-btn');
        if (!btn || btn.disabled) return;
        const section = this.closest('.shopify-section');
        if (this._invalidCombo) {
          const picker = section && section.querySelector('variant-picker');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        const pid = this.dataset.productId;
        const form = section && section.querySelector('product-form-component[data-product-id="' + pid + '"]');
        const mainBtn = form && form.querySelector('[ref="addToCartButton"]');
        if (mainBtn) mainBtn.click();
      }

      _resizeImg(src, width) {
        if (!src) return src;
        try {
          const u = new URL(src);
          u.searchParams.set('width', String(width));
          return u.toString();
        } catch (e) { return src; }
      }

      _money(cents) {
        if (cents == null) return '';
        const fmt = this.dataset.moneyFormat || '{{amount}}';
        const cur = this.dataset.currency || '';
        const val = Math.round(Number(cents));
        return fmt.replace(/{{\s*(\w+)\s*}}/g, (_, p) => {
          switch (p) {
            case 'amount': {
              const [i, d] = (val / 100).toFixed(2).split('.');
              return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
            }
            case 'amount_no_decimals':
              return String(Math.round(val / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            case 'amount_with_comma_separator': {
              const [i, d] = (val / 100).toFixed(2).split('.');
              return i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
            }
            case 'amount_no_decimals_with_comma_separator':
              return String(Math.round(val / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            case 'amount_with_space_separator': {
              const [i, d] = (val / 100).toFixed(2).split('.');
              return i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + d;
            }
            case 'amount_no_decimals_with_space_separator':
              return String(Math.round(val / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            case 'currency':
              return cur;
            default:
              return '';
          }
        });
      }

      _updateBar(variant) {
        if (!variant) return;
        const bar = this.querySelector('.sc-bar');
        if (!bar) return;

        const img = bar.querySelector('.sc-thumb-img');
        if (img) {
          const fi = variant.featured_image;
          const rawSrc = fi ? (typeof fi === 'string' ? fi : (fi.src || '')) : '';
          img.src = rawSrc ? this._resizeImg(rawSrc, 96) : (this._defaultImg || '');
          img.alt = fi ? (fi.alt || variant.title || '') : (variant.title || '');
        }

        const varEl = bar.querySelector('.sc-variant-text');
        if (varEl) varEl.textContent = variant.title === 'Default Title' ? '' : (variant.title || '');

        const priceEl = bar.querySelector('.sc-price-text');
        if (priceEl) {
          let h = '';
          let scPct = 0;
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            h += '<span class="compare-at-price"><bdi>' + this._money(variant.compare_at_price) + '</bdi></span>';
            scPct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          }
          h += '<span class="price"><bdi>' + this._money(variant.price) + '</bdi></span>';
          if (scPct >= 1) {
            h += '<span class="sc-discount-badge">-' + scPct + '%</span>';
          }
          priceEl.innerHTML = h;
        }

        const btn = bar.querySelector('.sc-btn');
        if (btn) {
          const addLabel = this.dataset.i18nAdd || '';
          const soldOutLabel = this.dataset.i18nSoldOut || '';
          if (variant.available) {
            btn.disabled = false;
            btn.textContent = addLabel;
          } else {
            btn.disabled = true;
            btn.textContent = soldOutLabel;
          }
        }
      }

      _updateBarInvalid(section) {
        const bar = this.querySelector('.sc-bar');
        if (!bar) return;
        const varEl = bar.querySelector('.sc-variant-text');
        if (varEl) {
          const picker = section && section.querySelector('variant-picker');
          if (picker) {
            const sel = Array.from(picker.querySelectorAll('input:checked, select option[selected]'))
              .map((el) => (el instanceof HTMLInputElement ? el.value : (el.textContent || el.value || '').trim()))
              .filter(Boolean).join(' / ');
            if (sel) varEl.textContent = sel;
          }
        }
        const btn = bar.querySelector('.sc-btn');
        if (btn) { btn.disabled = false; btn.textContent = this.dataset.i18nAdd || ''; }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
